module.exports = __webpack_public_path__ + "static/media/img2-3.240a078b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/biosense/diff/img2-3.png
// module id = 2290
// module chunks = 3